module.exports = __webpack_public_path__ + "img/look-back.b3a524b3.gif";